<template>
  <div class="flex flex-col min-h-screen overflow-hidden">
    <!-- Site header -->
    <Header />

    <!-- Page content -->
    <main class="flex-grow">
      <!-- Page illustration -->
      <div class="relative max-w-6xl mx-auto h-0 pointer-events-none" aria-hidden="true">
        <PageIllustration />
      </div>

      <section class="relative">
        <div class="max-w-6xl mx-auto px-4 sm:px-6 mt-24">
          <div class="gc_wrapper">
            <div class="responsive-iframe-container big-container">
              <!-- 埋め込み用 HTML コード -->
              <iframe
                src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=1&amp;bgcolor=%23ffffff&amp;ctz=Asia%2FTokyo&amp;src=czNhYXBocmtyOGtoY3NiaXY5Z3Rkc2NiMzhAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=cjJwOW0yczhlb3JlbXMzaTByMjE5OXFkb29AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=djRwbzh0b3ZxaWRna3JkNWx0YjhraWhkM3NAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=cmQ2aHZoZ3ZhMHRpcnBhN3BmbmFjaWs2ZjRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=bGU5a25hM21nN2Y4N3Y1aTZucmNiNGtrdG9AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;color=%23D50000&amp;color=%238E24AA&amp;color=%234285F4&amp;color=%238E24AA&amp;color=%230B8043"
                style="border:solid 1px #777"
                width="800"
                height="600"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </div>
            <!--end of .responsive-iframe-container big-container-->

            <div class="responsive-iframe-container small-container">
              <!-- 埋め込み用 HTML コード★ embed を htmlembed に変更-->
              <iframe
                src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=1&amp;bgcolor=%23ffffff&amp;ctz=Asia%2FTokyo&amp;src=czNhYXBocmtyOGtoY3NiaXY5Z3Rkc2NiMzhAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=cjJwOW0yczhlb3JlbXMzaTByMjE5OXFkb29AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=djRwbzh0b3ZxaWRna3JkNWx0YjhraWhkM3NAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=cmQ2aHZoZ3ZhMHRpcnBhN3BmbmFjaWs2ZjRAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=bGU5a25hM21nN2Y4N3Y1aTZucmNiNGtrdG9AZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;color=%23D50000&amp;color=%238E24AA&amp;color=%234285F4&amp;color=%238E24AA&amp;color=%230B8043"
                style="border:solid 1px #777"
                width="800"
                height="600"
                frameborder="0"
                scrolling="no"
              ></iframe
              >>
            </div>
            <!--end of .responsive-iframe-container small-container-->
          </div>
        </div>
      </section>
    </main>

    <!-- Site footer -->
    <Footer />
  </div>
</template>

<script>
import Header from "../partials/Header.vue"
import PageIllustration from "../partials/PageIllustration.vue"
import Footer from "../partials/Footer.vue"

export default {
  name: "Features",
  components: {
    Header,
    PageIllustration,
    Footer,
  },
}
</script>

<style lang="scss" scoped>
.gc_wrapper {
  max-width: 800px;
  min-width: 300px;
  margin: 2.0833% auto;
}

.responsive-iframe-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}
.responsive-iframe-container iframe,
.responsive-iframe-container object,
.responsive-iframe-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 600px) {
  .big-container {
    display: none;
  }
  .small-container {
    padding-bottom: 200%; /* 高さ */
  }
}
@media (min-width: 600px) {
  .small-container {
    display: none;
  }
}
</style>
